import { Controller } from "@hotwired/stimulus"

// Medical Lightbox controller - fullscreen image viewer with keyboard navigation
export default class extends Controller {
  static targets = ["modal", "image", "indicator", "prevButton", "nextButton", "imageData"]
  static values = {
    currentIndex: { type: Number, default: 0 },
    totalImages: { type: Number, default: 0 }
  }

  connect() {
    this.images = []
    this.currentPosition = 0
    this.totalImages = 0

    // Load image data from JSON
    if (this.hasImageDataTarget) {
      try {
        this.images = JSON.parse(this.imageDataTarget.textContent)
      } catch (e) {
        console.error("Failed to parse image data:", e)
      }
    }

    // Bind keyboard events
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    const index = parseInt(event.params.index, 10)
    const url = event.params.url
    const position = parseInt(event.params.position, 10)
    const total = parseInt(event.params.total, 10)

    this.currentIndexValue = index
    this.currentPosition = position
    this.totalImages = total

    this.showImage(url, position, total)
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.handleKeydown)
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.handleKeydown)
  }

  showImage(url, position, total) {
    if (url) {
      this.imageTarget.src = url
    }
    this.indicatorTarget.textContent = `Slice ${position} / ${total}`
  }

  previous() {
    const prevImage = this.findPreviousImage()
    if (prevImage) {
      this.currentIndexValue = prevImage.index
      this.currentPosition = prevImage.position
      this.showImage(prevImage.url, prevImage.position, this.totalImages)
    }
  }

  next() {
    const nextImage = this.findNextImage()
    if (nextImage) {
      this.currentIndexValue = nextImage.index
      this.currentPosition = nextImage.position
      this.showImage(nextImage.url, nextImage.position, this.totalImages)
    }
  }

  findPreviousImage() {
    const currentIdx = this.images.findIndex(img => img.index === this.currentIndexValue)
    if (currentIdx > 0) {
      return this.images[currentIdx - 1]
    }
    return null
  }

  findNextImage() {
    const currentIdx = this.images.findIndex(img => img.index === this.currentIndexValue)
    if (currentIdx < this.images.length - 1) {
      return this.images[currentIdx + 1]
    }
    return null
  }

  handleKeydown(event) {
    switch (event.key) {
      case "Escape":
        this.close()
        break
      case "ArrowLeft":
      case "ArrowUp":
        event.preventDefault()
        this.previous()
        break
      case "ArrowRight":
      case "ArrowDown":
        event.preventDefault()
        this.next()
        break
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }
}
